import React, { ReactNode } from "react";
import { Flex, FlexProps } from "@chakra-ui/react";

interface SideBarGroupSectionProps extends FlexProps {
  children?: ReactNode;
}
export const SideBarGroupSection: React.FC<SideBarGroupSectionProps> = ({ children, ...props }) => {
  return (
    <Flex
      w={"full"}
      flexDir={"column"}
      py={2.5}
      px={2}
      gap={1.5}
      overflowX={"hidden"}
      className="items-normal @[250px]/sidebar:items-start"
      {...props}
    >
      {children}
    </Flex>
  );
};
